import { render } from "./MyCreationsView.vue?vue&type=template&id=5271ada2&scoped=true"
import script from "./MyCreationsView.vue?vue&type=script&lang=js"
export * from "./MyCreationsView.vue?vue&type=script&lang=js"

import "./MyCreationsView.vue?vue&type=style&index=0&id=5271ada2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5271ada2"]])

export default __exports__